import { ReactElement, useState } from "react";
import { DatabaseSection, TargetSection } from "../../../../../lib/utils";
import { PersonDTO } from "../../../people/dto";
import { CompanyDTO } from "../../dto";
import { CreatePerson } from "./createPerson";
import { EditEmployee } from "./editEmployee";
import { CompanyEmployeesList } from "./list";
import { ContactEmployeesResponse } from "../../../../targetList/contacts/dto";

interface Props {
  employees: PersonDTO[]
  companyId?: string
  section: DatabaseSection | TargetSection;
  company: CompanyDTO
  contactEmployees?: ContactEmployeesResponse
}

export function CompanyEmployees(props: Props) {
  const { employees, section, company, contactEmployees } = props


  const [personPage, setPersonPage] = useState<"list" | "new" | "edit">("list")
  const [employee, setEmployee] = useState<PersonDTO | undefined>(undefined)

  const personPageMap = new Map<"list" | "new" | "edit", ReactElement>([
    ['list', <CompanyEmployeesList section={section} contactEmployees={contactEmployees} companyId={company?.id} isInTargetList={section === "target"} employees={employees} navigate={setPersonPage} setEmployee={setEmployee} />],
    ['new', <CreatePerson inTargetList={section === "target"} navigate={setPersonPage} company={company!} />],
    ['edit', <EditEmployee employee={employee} isInTargetList={section === "target"} navigate={setPersonPage} contact={contactEmployees ? contactEmployees.employeesContacts.find(c => c.contactId === employee?.id) : undefined} />],
  ])
  return <>{personPageMap.get(personPage)}</>;
}
